document.querySelectorAll('.tpt-technology').forEach((section) => {
  const compareContent = section.querySelector(
    '[data-tech-compare-source]'
  );

  if (!compareContent) return;

  section
    .querySelectorAll('.tpt-technology__compare-container')
    .forEach((container) => {
      container.innerHTML = '';
      container.appendChild(compareContent.cloneNode(true));
    });
});